import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { DateComponent } from '../../../components/DateComponent';
import { numberFormatter } from '../../../utils/utilities';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../../../components/merchants/RelatedEntityNameLink';

export enum PartnersDealsDetailsDataTableAccessorKeys {
	mid = 'mid',
	startDate = 'startDate',
	endDate = 'endDate',
	revenueGrossCommissions = 'revenueGrossCommissions',
	revenueNetCommissions = 'revenueNetCommissions',
	orderCommissions = 'orderCommissions',
}

export const defaultPartnersDealsDetailsColumnSizing: ColumnSizing = {
	[PartnersDealsDetailsDataTableAccessorKeys.mid]: 100,
	[PartnersDealsDetailsDataTableAccessorKeys.startDate]: 50,
	[PartnersDealsDetailsDataTableAccessorKeys.endDate]: 50,
	[PartnersDealsDetailsDataTableAccessorKeys.revenueGrossCommissions]: 100,
	[PartnersDealsDetailsDataTableAccessorKeys.revenueNetCommissions]: 100,
	[PartnersDealsDetailsDataTableAccessorKeys.orderCommissions]: 100,
};

export const defaultPartnersDealsDetailsColumns: MRT_ColumnDef<IDetailsMockData>[] = [
	{
		accessorKey: PartnersDealsDetailsDataTableAccessorKeys.mid,
		header: 'Merchant name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Merchant name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<RelatedEntityNameLink id={renderedCellValue} type={RELATED_ENTITY_TYPE.MERCHANT} />
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDetailsDataTableAccessorKeys.startDate,
		header: 'Start deal date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Start deal date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<DateComponent value={renderedCellValue} />
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDetailsDataTableAccessorKeys.endDate,
		header: 'End deal date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">End deal date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<DateComponent value={renderedCellValue} />
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDetailsDataTableAccessorKeys.revenueGrossCommissions,
		header: 'Commission on gross revenue',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commission on gross revenue</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? renderedCellValue : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDetailsDataTableAccessorKeys.revenueNetCommissions,
		header: 'Commissions on net revenue',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commissions on net revenue</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? `${numberFormatter(renderedCellValue)}%` : '-'}
			</TableCell>
		)
	},
	{
		accessorKey: PartnersDealsDetailsDataTableAccessorKeys.orderCommissions,
		header: 'Commissions on order',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commissions on order</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="fs-7"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue ? `$${numberFormatter(renderedCellValue)}` : '-'}
			</TableCell>
		)
	},
];

interface IDetailsMockData {
	mid: string,
	startDate: string,
	endDate: string,
	revenueGrossCommissions: number,
	revenueNetCommissions: number,
	orderCommissions: number,
}

export const mockDetailData: IDetailsMockData[] = [
	{
		mid: 'be709bee-2fc1-49a5-beb4-6ed75d8fa33b',
		startDate: '2023-03-23T18:19:24.700293Z',
		endDate: '2024-09-23T18:19:24.700293Z',
		revenueGrossCommissions: null,
		revenueNetCommissions: 50,
		orderCommissions: 0.03,
	},
	{
		mid: '4f9ef66c-6a33-4b8f-9a6a-4db33720b2e0',
		startDate: '2023-03-23T18:19:24.700293Z',
		endDate: '2024-09-23T18:19:24.700293Z',
		revenueGrossCommissions: null,
		revenueNetCommissions: 50,
		orderCommissions: 0.03,
	},
	{
		mid: '358898d5-9025-4434-a954-d2415e61a767',
		startDate: '2023-03-23T18:19:24.700293Z',
		endDate: '2024-09-23T18:19:24.700293Z',
		revenueGrossCommissions: null,
		revenueNetCommissions: 50,
		orderCommissions: 0.03,
	},
	{
		mid: '76e105a7-4d60-457b-82f2-648d46aba287',
		startDate: '2023-03-23T18:19:24.700293Z',
		endDate: '2024-09-23T18:19:24.700293Z',
		revenueGrossCommissions: null,
		revenueNetCommissions: 50,
		orderCommissions: 0.03,
	},
	{
		mid: 'c0b80b03-eb7a-4ebd-8418-b095c5dee20a',
		startDate: '2023-03-23T18:19:24.700293Z',
		endDate: '2024-09-23T18:19:24.700293Z',
		revenueGrossCommissions: null,
		revenueNetCommissions: 50,
		orderCommissions: 0.03,
	},
];
